import React from 'react';
import { Button, Modal } from 'react-bootstrap';

import { dateTimeSlashesFormat } from 'App/services/DateService';
import propOrDash from 'App/utils/propOrDash';
import localize from 'App/utils/localize/localize';
import TherigyInfoMessage from '../TherigyInfoMessage/TherigyInfoMessage';
import Table from '../Table/Table';
import useGetReferralHistory from 'App/hooks/useGetReferralHistory';
import { referralModalPropType } from '../AddReferralActivity/types';

const defaultProps = {};

const columns = [
    {
        Header: 'Status',
        accessor: propOrDash('status'),
        id: 'status',
    },
    {
        Header: 'Status Reason',
        accessor: propOrDash('statusReason'),
        id: 'statusReason',
    },
    {
        Header: 'Last Updated',
        accessor: 'updatedOn',
        Cell: ({ value }) => (value ? localize(value, dateTimeSlashesFormat) : '--'),
        id: 'updatedOn',
    },
    {
        Header: 'User',
        accessor: (row) => `${row.updatedName.firstName} ${row.updatedName.lastName}`.trim(),
        id: 'updatedName',
    },
];

const initialState = {
    sortBy: [
        {
            id: 'updatedOn',
            desc: true,
        },
    ],
};

const ReferralHistoryModal = ({ show, onHide, patientId, referralId }) => {
    const { data: history, isLoading } = useGetReferralHistory(patientId, referralId);

    return (
        <Modal size="lg" show={show} onHide={() => onHide(false)} backdrop="static" className="referral-history">
            <Modal.Header>
                <Modal.Title role="heading">Referral Status History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {history?.length > 0 && !isLoading ? (
                    <Table
                        initialState={initialState}
                        enablePagination={false}
                        columns={columns}
                        data={history}
                        isLoading={isLoading}
                    />
                ) : (
                    <TherigyInfoMessage message="There is no history for this referral." />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => onHide(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ReferralHistoryModal.propTypes = referralModalPropType;
ReferralHistoryModal.defaultProps = defaultProps;

export default ReferralHistoryModal;
